<template>
    <div id="myDateShow">
        <div class="title">分销设置</div>
        <div id="dataShow">
            <div class="line">
                <div class="key" style="font-size: 20px;">分销模式</div>
            </div>
            <div class="line">
                <div class="key">是否分销</div>
                <div class="value">
                    <el-switch v-model="configuration.switch" active-value="Y" inactive-value="N" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </div>
            </div>
            <div class="line">
                <div class="key">返佣设置（以下百分比参数可修改或适当调整）</div>
            </div>

            <div class="line" style="display: flex;">
                <div class="key" style="margin-right: 25px;">返佣层级（默认固定为二级：直推和间推，暂无更改）</div>
                <div class="value" style="display:flex;">
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="2" status="warning" style="width: 350px;display: flex;align-items: center;justify-content: center;"></el-progress>
                </div>
            </div>
            <div class="line" style="display: flex;">
                <div class="key" style="margin-right: 95px;">直推返佣</div>
                <div class="value" style="display:flex;">
                    <el-button size="mini" icon="el-icon-minus" @click="increase('directPush')" circle></el-button>
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="configuration.directPush" style="width: 350px;display: flex;align-items: center;justify-content: center;"></el-progress>
                    <el-button size="mini" icon="el-icon-plus" @click="decrease('directPush')" circle></el-button>
                </div>
            </div>

            <div class="line" style="display: flex;">
                <div class="key" style="margin-right: 95px;">间推返佣</div>
                <div class="value" style="display:flex;">
                    <el-button size="mini" icon="el-icon-minus" @click="increase('interpenetration')" circle></el-button>
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="configuration.interpenetration" style="width: 350px;display: flex;align-items: center;justify-content: center;"></el-progress>
                    <el-button size="mini" icon="el-icon-plus" @click="decrease('interpenetration')" circle></el-button>
                </div>
            </div>

            <div class="line" style="display: flex;">
                <div class="key" style="margin-right: 125px;">平台收益</div>
                <div class="value" style="display:flex;">
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="configuration.commissionPlatformRevenue" style="width: 350px;display: flex;align-items: center;justify-content: center;"></el-progress>
                </div>
            </div>
            <div class="line"></div>
            <div class="line">
                <div class="key" style="font-size: 20px;">没有以上的返佣层级，仅0级推广大使自己购买商品时：</div>
            </div>
            <div class="line" style="display: flex;">
                <div class="key" style="margin-right: 50px;">无推佣金（佣金设定收益范围值为：1-5%）</div>
                <div class="value" style="display:flex;">
                    <el-button size="mini" icon="el-icon-minus" @click="increase('noServant')" circle></el-button>
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="configuration.noServant" style="width: 350px;display: flex;align-items: center;justify-content: center;"></el-progress>
                    <el-button size="mini" icon="el-icon-plus" @click="decrease('noServant')" circle></el-button>
                </div>
            </div>
            <div class="line" style="display: flex;">
                <div class="key" style="margin-right: 125px;">平台收益</div>
                <div class="value" style="display:flex;">
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="configuration.noServantPlatformRevenue" style="width: 350px;display: flex;align-items: center;justify-content: center;"></el-progress>
                </div>
            </div>
            <div class="line">
                <div class="key">佣金自助提现</div>
                <div class="value">
                    <el-switch v-model="configuration.automaticReflection" active-value="Y" inactive-value="N" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </div>
            </div>
            <div class="line">
                <div class="key" style="font-size: 20px;">推广大使设置</div>
            </div>
            <div class="line">
                <div class="key">购买任意一件商品成为推广大使</div>
                <div class="value">
                    <el-switch v-model="configuration.purchaseGoods" active-value="Y" inactive-value="N" active-color="#13ce66"
                               inactive-color="#ff4949"></el-switch>
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
                </div>
            </div>
            <div class="line"></div>
        </div>
    </div>
</template>

<script>
    import {queryPmConfiguration, saveOrUpdatePmConfiguration, newVue} from "../../network/configuration";

    export default {
        name: "distributionConfiguration",
        data() {
            return {
                id:null,
                code: "Distribution",
                configuration: {
                    directPush:45,
                    interpenetration:5,
                    commissionPlatformRevenue:50,
                    noServant:1,
                    noServantPlatformRevenue:99
                },
                headers: {},
            }
        },
        created() {
            newVue.obj = this;
            this.headers.Authorization = this.authorization;
            this.common.HeaderLocationTwo.href = "/distribution/distributionConfiguration";
            this.common.HeaderLocationTwo.name = "公共设置";
            this.common.HeaderLocationThree.name = "分销设置";
            queryPmConfiguration(this.code).then(res => {
                if (res.data != null) {
                    this.id = res.data.id;
                    this.configuration = JSON.parse(res.data.configuration);
                }
            })
        },
        methods: {
            submit() {
                var configuration = {
                    code:"Distribution",
                    configuration:JSON.stringify(this.configuration)
                };
                if (this.id !=null){
                    configuration["id"] = this.id;
                }
                console.log(configuration);
                saveOrUpdatePmConfiguration(configuration).then(res => {
                })
            },
            decrease(code){//增加百分比
                switch (code) {
                    case "directPush":
                        this.configuration.directPush += 1;
                        if (this.configuration.directPush > 100) {
                            this.configuration.directPush = 100;
                        }
                        break;
                    case "interpenetration":
                        this.configuration.interpenetration += 1;
                        if (this.configuration.interpenetration > 100) {
                            this.configuration.interpenetration = 100;
                        }
                        break;
                    case "noServant":
                        this.configuration.noServant += 0.1;
                        this.configuration.noServant = parseFloat(this.configuration.noServant.toFixed(1));
                        if (this.configuration.noServant > 5) {
                            this.configuration.noServant = 5;
                        }
                        break;
                }
                if(this.configuration.interpenetration && this.configuration.directPush){
                    this.configuration.commissionPlatformRevenue = 100 - this.configuration.interpenetration - this.configuration.directPush;
                }
                if (this.configuration.noServant){
                    this.configuration.noServantPlatformRevenue=100-this.configuration.noServant;
                }
            },
            increase(code){//减少百分比
                switch (code) {
                    case "directPush":
                        this.configuration.directPush -= 1;
                        if (this.configuration.directPush < 0) {
                            this.configuration.directPush = 0;
                        }
                        break;
                    case "interpenetration":
                        this.configuration.interpenetration -= 1;
                        if (this.configuration.interpenetration < 0) {
                            this.configuration.interpenetration = 0;
                        }
                        break;
                    case "noServant":
                        this.configuration.noServant -= 0.1;
                        this.configuration.noServant = parseFloat(this.configuration.noServant.toFixed(1));
                        if (this.configuration.noServant < 1) {
                            this.configuration.noServant = 1;
                        }
                        break;
                }
                if(this.configuration.interpenetration && this.configuration.directPush){
                    this.configuration.commissionPlatformRevenue = 100 - this.configuration.interpenetration - this.configuration.directPush;
                }
                if (this.configuration.noServant){
                    this.configuration.noServantPlatformRevenue=100-this.configuration.noServant;
                }
            }
        }
    }
</script>

<style scoped>
    @import "../../assets/css/data.css";

    .w500 {
        width: 500px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
